import Animation from './animation'
import { EPSILON } from 'chart-constants'
import * as colors from 'colors'

class BasicAnimation extends Animation {

  match (serie) {
    // Final catch all, make sure this runs last
    return true
  }

  animate (serie, entering, selection, merged, exiting) {
    let enter = merged.selection()
                      .selectAll('path')
                      .data(d => {
                        if (this.chart.layout.breakdown.calculated) {
                          return [] // We can't draw a path if it's a single point. See #579
                        }
                        // Graph only points where we have data, so we have a continuous circle
                        let points = d.points.filter(point => {
                          return point && !isNaN(point.raw)
                        })
                        return [points, points] // Two lines
                      })
                      .enter()
                      .append('path')
                      .classed('outer-line', (d, i) => i === 0)
                      .attr('d', d => {
                        let min = this.yScale.range()[0]
                        return this.lineGenerator(d.map(point => {
                          return {
                            raw: min,
                            rangeId: point.rangeId
                          }
                        }))
                      })
                      .style('fill-opacity', d => {
                        return serie.fill ? 1 : EPSILON
                      })
      , path = enter.merge(merged.selection().selectAll('path'))
                    // .transition(merged) // inherit the transition // Disabling transitions on polar charts for now

    // Fill both lines
    path.attr('d', this.lineGenerator)
        // Set opacity of the fill based on the `serie.fill`
        .style('fill-opacity', d => serie.fill ? 1 : EPSILON)
        .filter((d, i) => i > 0)
        .style('stroke', colors.mixBlack(colors.lookupObj(serie.color).rgba, .12))
        .style('fill', colors.mixBlack(colors.lookupObj(serie.color).rgba, .12))

    // Hide the first line for filled polar charts
    path.filter((d, i) => i === 0)
        .style('opacity', serie.fill ? EPSILON : null)

    // Filled polar charts are half opaque
    path.filter((d, i) => i > 0)
        .style('opacity', serie.fill ? .5 : null)

    if (this.yScale) {
      exiting.selectAll('path')
           .attr('d', d => {
             let min = this.yScale.range()[0]
             return this.lineGenerator(d.map(point => {
               return {
                 raw: min,
                 rangeId: point.rangeId
               }
             }))
           })
    } else {
      exiting.remove()
    }

  }

}

export default BasicAnimation
